<template>
  <div class="authentication-wrapper authentication-2 ui-bg-cover ui-bg-overlay-container px-4" :style="`background-image: url('${publicUrl}img/bg/1.jpg');`">
    <div class="ui-bg-overlay bg-dark opacity-25"></div>

    <div class="authentication-inner py-5">

      <b-card no-body>
        <div class="p-4 p-sm-5">
          <!-- Logo -->
<!--          <div class="d-flex justify-content-center align-items-center pb-2 mb-4">-->
<!--            <div class="ui-w-60">-->
<!--              <div class="w-100 position-relative" style="padding-bottom: 54%">-->
<!--                <svg class="w-100 h-100 position-absolute" viewBox="0 0 148 80" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="a" x1="46.49" x2="62.46" y1="53.39" y2="48.2" gradientUnits="userSpaceOnUse"><stop stop-opacity=".25" offset="0"></stop><stop stop-opacity=".1" offset=".3"></stop><stop stop-opacity="0" offset=".9"></stop></linearGradient><linearGradient id="e" x1="76.9" x2="92.64" y1="26.38" y2="31.49" xlink:href="#a"></linearGradient><linearGradient id="d" x1="107.12" x2="122.74" y1="53.41" y2="48.33" xlink:href="#a"></linearGradient></defs><path class="fill-primary" transform="translate(-.1)" d="M121.36,0,104.42,45.08,88.71,3.28A5.09,5.09,0,0,0,83.93,0H64.27A5.09,5.09,0,0,0,59.5,3.28L43.79,45.08,26.85,0H.1L29.43,76.74A5.09,5.09,0,0,0,34.19,80H53.39a5.09,5.09,0,0,0,4.77-3.26L74.1,35l16,41.74A5.09,5.09,0,0,0,94.82,80h18.95a5.09,5.09,0,0,0,4.76-3.24L148.1,0Z"></path><path transform="translate(-.1)" d="M52.19,22.73l-8.4,22.35L56.51,78.94a5,5,0,0,0,1.64-2.19l7.34-19.2Z" fill="url(#a)"></path><path transform="translate(-.1)" d="M95.73,22l-7-18.69a5,5,0,0,0-1.64-2.21L74.1,35l8.33,21.79Z" fill="url(#e)"></path><path transform="translate(-.1)" d="M112.73,23l-8.31,22.12,12.66,33.7a5,5,0,0,0,1.45-2l7.3-18.93Z" fill="url(#d)"></path></svg>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; / Logo &ndash;&gt;-->

          <div class="d-flex justify-content-center align-items-center pb-2 mb-1 text-center">
            <div class="text-center">
              <div class="text-center">
                <img src="/img/hayrat.png" width="120" height="120"/>
                <img src="/img/yemre.png" width="140"/>
              </div>
            </div>
          </div>
          <h5 class="text-center text-muted font-weight-normal mb-1">Giriş</h5>

          <!-- Form -->
          <form>
            <b-form-group label="E Posta">
              <b-input v-model.trim="email"  />
            </b-form-group>
            <b-form-group v-if="kodGeldi" label="Giriş Kodunuzu Yazınız">
              <b-input type="password" v-model.trim.number="kod"  />
            </b-form-group>
            <div class="justify-content-center align-items-center m-0">
              <!--              <b-check v-model="credentials.rememberMe" class="m-0">Remember me</b-check>-->
              <!--              <b-btn variant="primary" block>{{buttonText}}</b-btn>-->
              <b-row>
               <b-col class="text-center">
                 <ladda-btn v-if="!kodGeldi" :loading="yukleniyor" @click.native="startLoading()"
                            data-style="slide-right"
                            class="btn btn-info">
                   Giriş Yap</ladda-btn>
                 <ladda-btn v-if="kodGeldi" :loading="yukleniyor" @click.native="startLoading()"
                            data-style="slide-right"
                            class="btn btn-info">
                   Giriş Yap</ladda-btn>
               </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col class="text-center">
                  <ladda-btn v-if="kodGeldi" :loading="yukleniyor" @click.native="kodGelmedi()"
                             data-style="slide-right"
                             class="btn btn-info">
                    Yeni Kod İste</ladda-btn>
                </b-col>
              </b-row>
            </div>
          </form>
          <!-- / Form -->

        </div>
        <b-card-footer class="py-3 px-4 px-sm-5">
        <div class="text-center text-muted">
          Hesabın Yok Mu? <a href="/kayit">Kayıt Ol</a>
        </div>
      </b-card-footer>
        <b-card-footer class="py-3 px-4 px-sm-5">
          <div class="text-center text-muted">
            <a @click="aydinlatma">Aydınlatma Metni İçin Tıklayınız</a>
          </div>
        </b-card-footer>
      </b-card>

    </div>
    <div class="d-inline-block">
      <sweet-modal icon="error" ref="errorAlert">
        <ul>
          <li v-for="(hata, index) in hatalar" :key="index">
            {{hata}}
          </li>
        </ul>
      </sweet-modal>
    </div>
  </div>
</template>

<!-- Page -->
<style src="@/vendor/styles/pages/authentication.scss" lang="scss"></style>

<script>
import LaddaBtn from '@/vendor/libs/ladda/Ladda'
import { SweetModal } from 'sweet-modal-vue'
import { getError } from '@/Ex/ErrorSplit'
import { giris, kodYolla } from '../../api/auth'
import { getToken } from '@/utils/auth'
export default {
  components: {
    LaddaBtn,
    SweetModal
  },
  name: 'pages-authentication-login-v2',
  metaInfo: {
    title: 'Giriş'
  },
  data: () => ({
    yukleniyor: false,
    email: '',
    kodGeldi: false,
    kod: '',
    buttonText: 'Kod İste',
    hatalar: []
  }),
  methods: {
    async startLoading () {
      if (this.yukleniyor) return
      this.hatalar = []
      this.yukleniyor = true
      await this.girisYap()
    },
    async kodGelmedi () {
      this.yukleniyor = true
      try {
        await kodYolla(this.email, true)
      } catch (e) {
        this.hatalar = getError(e)
        this.$refs.errorAlert.open()
      }
      this.yukleniyor = false
    },
    async loginSystem () {
      var burasi = this
      this.yukleniyor = true
      try {
        let result = await giris(this.email, this.kod)
        await this.$store.dispatch('setTokenData', result.data.data)
        await burasi.$router.push(this.$route.query.returnUrl || '/anasayfa')
      } catch (e) {
        console.log(e)
        this.hatalar = getError(e)
        this.$refs.errorAlert.open()
      }
      this.yukleniyor = false
    },
    async sendCode () {
      this.yukleniyor = true
      try {
        await kodYolla(this.email)
        this.kodGeldi = true
        this.buttonText = 'Giriş Yap'
      } catch (e) {
        this.hatalar = getError(e)
        this.$refs.errorAlert.open()
      }
      this.yukleniyor = false
    },
    async girisYap () {
      if (!this.kodGeldi) {
        await this.sendCode()
      } else {
        await this.loginSystem()
      }
    },
    aydinlatma () {
      window.location = '/aydinlatma.pdf'
    }
  },
  mounted () {
    if (getToken('tokenYE')) {
      this.$router.push(this.$route.query.returnUrl || '/anasayfa')
    }
    // sayfa yüklenince bakcaz. id token var mı?
    // id token varsa apiye yolllucaz
    // id token yoksa hiç bi işlem yapma
  },
  beforeDestroy () {
    if (this.$refs.errorAlert) {
      this.$refs.errorAlert.close()
    }
    if (this.$refs.successAlert) {
      this.$refs.successAlert.close()
    }
  }
}
</script>

<style scoped>
  li {
    list-style-type: none;
  }
  ul{
    padding: 0px;
    margin: 0px;
  }
</style>
